/** Formatos de micros sin grabación en sucursal de la óptica */
export const microFormats = [
  {
    title: 'Micro en estudio TNO',
    description:
      'Presentador/a o locución profesional con branding Berlud: tips de salud visual, campañas de exámenes o promociones. Se graba en nuestro set.',
  },
  {
    title: 'Pieza con material de marca',
    description:
      'Fotos de monturas, catálogo, logos y piezas promocionales que nos compartan: TNO arma el video con edición, música y subtítulos.',
  },
  {
    title: 'Motion / plantilla animada',
    description:
      'Video corto con eslogan, beneficios y llamado a la acción usando la identidad visual de Berlud — ideal para rotativa y redes.',
  },
  {
    title: 'Derivado de programa o Digest',
    description:
      'Clips a partir de menciones en programas de salud del ecosistema TNO o de artículos TNO Digest ya publicados.',
  },
  {
    title: 'Entrevista con vocero (Plan Oro)',
    description:
      'Vocero de Berlud conectado por videollamada al estudio TNO: conversación de 3–5 minutos integrada al look del medio y lista para redes.',
  },
  {
    title: 'Adaptación de su contenido',
    description:
      'Si ya tienen reels o videos propios, TNO puede adaptarlos (ritmo, marca, formato vertical) para la señal y las redes del ecosistema.',
  },
];

export default microFormats;
